import { axiosPatientInstance } from "config";
import { useAxiosQuery } from "hooks";

function useGetFinancialReport(
  startDate: Date | null,
  endDate: Date | null,
  options?: { enabled: boolean }
) {
  return useAxiosQuery(
    ["scheduleReport", { startDate, endDate }],
    () =>
      axiosPatientInstance.get<Blob>(`v1/financial-report`, {
        responseType: "blob",
        params: { startDate, endDate },
      }),
    { ...options }
  );
}

export { useGetFinancialReport };
